import i18nFactory from '@yandex-int/i18n';
import { Button, Icon } from 'lego-on-react';
import * as React from 'react';

import { Bem } from '../../../service/Bem/Bem';
import {
    EditorVideoAdditionRateCorrectionCondition,
    RateControlValue,
    RateCorrectionConditionId,
    RateCorrectionType
} from '../../../typings/ratesCorrections';
import { RateControl } from '../../RateControl/RateControl';

import './RatesCorrectionsListVideoAdditionCondition.css';
import * as keyset from './RatesCorrectionsListVideoAdditionCondition.i18n';

const i18n = i18nFactory(keyset);

export type onChangeVideoAdditionConditionParams = {
    type: RateCorrectionType.videoAddition;
    value: EditorVideoAdditionRateCorrectionCondition;
    id: RateCorrectionConditionId;
};

export interface RatesCorrectionsListVideoAdditionConditionProps {
    value: EditorVideoAdditionRateCorrectionCondition;
    maxRate?: number;
    minRate?: number;
    isDisabled: boolean;
    onChange: (params: onChangeVideoAdditionConditionParams) => void;
}

const blockClass = 'rates-corrections-list-video-addition-condition';

export class RatesCorrectionsListVideoAdditionCondition extends React.PureComponent<
    RatesCorrectionsListVideoAdditionConditionProps
> {
    render() {
        const { isDisabled, minRate, maxRate, value } = this.props;

        return (
            <div className={blockClass}>
                <Button
                    cls={Bem.cls(blockClass, 'selector')}
                    theme="normal"
                    view="classic"
                    size="s"
                    width="max"
                    disabled={true}
                    iconRight={<Icon size={'n'} type={'arrow'} direction={'bottom'} />}
                >
                    {i18n('button-text')}
                </Button>

                <RateControl
                    value={value.value}
                    max={maxRate}
                    min={minRate}
                    isDisabled={isDisabled}
                    isCommon={false}
                    errors={value.errors.value}
                    onChange={this.onRateControlChange}
                />
            </div>
        );
    }

    private onRateControlChange = (rate: RateControlValue) => {
        const { value, onChange } = this.props;

        onChange({
            type: RateCorrectionType.videoAddition,
            id: value.id,
            value: {
                ...value,
                value: rate
            }
        });
    };
}
